export const navMenuItemDataTestIds = {
  blog: 'blog',
  contests: 'contests',
  dashboard: 'dashboard',
  loyaltyProgram: 'loyalty-program',
  offers: 'offers',
  offersByAdvertisers: 'offers-by-advertisers',
  offersByOffers: 'offers-by-offers',
  payments: 'payments',
  postbacks: 'postbacks',
  postbacksGeneral: 'postbacks-general',
  postbacksTelegram: 'postbacks-telegram',
  profile: 'profile',
  profileKyc: 'profile-kyc',
  profileSecurity: 'profile-security',
  profileSettings: 'profile-settings',
  promo: 'promo',
  statistics: 'statistics',
  statisticsByUsers: 'statistics-by-users',
  statisticsGeneral: 'statistics-general',
  subAffiliate: 'sub-affiliate',
  top: 'top',
} as const

const NAV_MENU_ITEM_DATA_TEST_ID_PREFIX = 'navbar-nav-menu.item-'

export const getNavMenuItemDataTestId = (dataTestId?: string) => `${NAV_MENU_ITEM_DATA_TEST_ID_PREFIX}${dataTestId}`
